import React from 'react';

export default function AboutUsPage() {
  return (
    <div className="bg-gray-50 text-gray-800 px-4 md:px-20 py-16 font-sans">

      {/* Hero Section */}
      <section className="text-center max-w-4xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">Empowering Advertisers with Smart Decisions</h1>
        <p className="text-lg md:text-xl text-gray-600">
          At AdMentorAI, we're building the smartest ad optimization platform—powered by data, psychology, and automation.
        </p>
      </section>

      {/* Mission */}
      <section className="mt-20 max-w-4xl mx-auto text-center">
        <h2 className="text-3xl font-semibold mb-4">🚀 Our Mission</h2>
        <p className="text-gray-700 text-lg">
          To help startups, agencies, and marketers run highly converting ads without being data scientists or ad ninjas.
        </p>
      </section>

      {/* Story */}
      <section className="mt-20 grid md:grid-cols-2 gap-12 max-w-6xl mx-auto">
        <div>
          <h3 className="text-2xl font-semibold mb-3">How It All Started</h3>
          <p className="text-gray-700">
            AdMentorAI was born from the frustration of wasting ad budgets. After managing campaigns across platforms,
            we realized most businesses don’t fail because of bad ideas—they fail because of poor ad targeting, unclear messaging,
            and overwhelming dashboards. We decided to simplify this chaos.
          </p>
        </div>
        <div className="bg-white p-6 rounded shadow">
          <h4 className="text-lg font-medium mb-2">💡 3 Founders. 1 Vision.</h4>
          <p>
            Developers, marketers, and behaviorists came together to create an AI-first tool that not only runs ads but
            understands human behavior. We blend machine intelligence with persuasion psychology.
          </p>
        </div>
      </section>

      {/* What We Solve */}
      <section className="mt-20 max-w-5xl mx-auto text-center">
        <h3 className="text-3xl font-semibold mb-6">🧩 The Problem We Solve</h3>
        <ul className="space-y-4 text-left max-w-3xl mx-auto text-gray-700">
          <li>✅ Confusing ad dashboards across Meta, Google, LinkedIn</li>
          <li>✅ Unclear what’s working and why</li>
          <li>✅ High bounce rates, poor conversions</li>
          <li>✅ Lack of psychology-based creative strategy</li>
        </ul>
      </section>

      {/* Team */}
      <section className="mt-20 max-w-6xl mx-auto">
        <h3 className="text-3xl font-semibold text-center mb-10">👥 Meet the Core Team</h3>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 text-center">
          <div className="bg-white p-4 rounded shadow">
            <div className="w-24 h-24 mx-auto rounded-full bg-gray-200" />
            <h4 className="mt-4 font-bold">Faijan Memon</h4>
            <p className="text-sm text-gray-600">Founder & Fullstack Engineer</p>
          </div>
          <div className="bg-white p-4 rounded shadow">
            <div className="w-24 h-24 mx-auto rounded-full bg-gray-200" />
            <h4 className="mt-4 font-bold">Fardeen Memon</h4>
            <p className="text-sm text-gray-600">Growth Strategist</p>
          </div>
          <div className="bg-white p-4 rounded shadow">
            <div className="w-24 h-24 mx-auto rounded-full bg-gray-200" />
            <h4 className="mt-4 font-bold">Farhan Memon</h4>
            <p className="text-sm text-gray-600">AI/ML Engineer</p>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="mt-20 max-w-4xl mx-auto text-center">
        <h3 className="text-3xl font-semibold mb-6">📊 What We’ve Achieved</h3>
        <div className="grid md:grid-cols-3 gap-8 text-lg text-gray-800 font-medium">
          <div>
            <p className="text-4xl font-bold text-blue-600">12+</p>
            Early Adopters
          </div>
          <div>
            <p className="text-4xl font-bold text-blue-600">93%</p>
            Conversion Boosts
          </div>
          <div>
            <p className="text-4xl font-bold text-blue-600">4.8⭐</p>
            User Satisfaction
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="mt-20 max-w-5xl mx-auto text-center">
        <h3 className="text-3xl font-semibold mb-6">🌱 Our Core Values</h3>
        <ul className="space-y-4 text-left max-w-3xl mx-auto text-gray-700">
          <li>💡 Simplicity over complexity</li>
          <li>🧠 Psychology-first design thinking</li>
          <li>📈 Data-backed decisions</li>
          <li>🙌 User obsession. Always.</li>
        </ul>
      </section>

      {/* CTA */}
      <section className="mt-20 text-center">
        <h3 className="text-2xl font-semibold mb-4">Want to Work With Us?</h3>
        <p className="text-gray-600 mb-6">We're always looking for curious minds. If you're passionate about ads, data, or design—let's talk.</p>
        <button className="px-6 py-3  bg-blue-100 text-blue-700 font-semibold rounded hover:bg-blue-400 hover:text-white transition">
          Contact Us
        </button>
      </section>

    </div>
  );
}
